import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constructor() { }

  log(message: string): void {
     
    console.debug(message);
     
  }

  error(error: Error): void {
    console.error({message: error.message, stackTrace: error.stack});
  }
}
